module.exports = __webpack_public_path__ + "img/browser-msedge-logo.787178a4.webp";